import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
//import moment from 'moment';
const moment = require('moment');
import { values } from 'lodash';
import { SystemInfoConsts } from '../models/constants';
import { NavigationTarget } from './constants';
import { environment } from 'src/environments/environment';

@Injectable()
export class Utilities {
    public static readonly captionAndMessageSeparator = ':';
    public static readonly noNetworkMessageCaption = 'No Network';
    public static readonly noNetworkMessageDetail = 'The server cannot be reached';
    public static readonly accessDeniedMessageCaption = 'Access Denied!';
    public static readonly accessDeniedMessageDetail = '';
    public static readonly printDelay: number = 0;
    public static readonly scriptPrintOnLoad = "<script>function triggerPrint(event) {window.removeEventListener('load', triggerPrint, false);setTimeout(function() {closeWindow(window.print());}, 0);}function closeWindow(){window.close();}window.addEventListener('load', triggerPrint, false);</script>";

    public static getHttpErrorDescription(error: HttpErrorResponse): string {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            return error.error.message;
        } else {
            // The backend returned an unsuccessful response code. The response body may contain clues as to what went wrong.
            return error.error;
        }
    }

    public static getHttpResponseMessage(data: HttpResponse<any> | any): string[] {
        let responses: string[] = [];

        if (data instanceof HttpResponse) {
            if (this.checkNoNetwork(data)) {
                responses.push(`${this.noNetworkMessageCaption}${this.captionAndMessageSeparator} ${this.noNetworkMessageDetail}`);
            } else {
                try {
                    let responseObject = data.body;

                    for (let key in responseObject) {
                        if (key) responses.push(`${key}${this.captionAndMessageSeparator} ${responseObject[key]}`);
                        else if (responseObject[key]) responses.push(responseObject[key].toString());
                    }
                } catch (error) { }
            }

            if (!responses.length && data.statusText) responses.push(data.statusText);
        }

        if (!responses.length) responses.push(data.toString());

        if (this.checkAccessDenied(data)) responses.splice(0, 0, `${this.accessDeniedMessageCaption}${this.captionAndMessageSeparator} ${this.accessDeniedMessageDetail}`);

        return responses;
    }

    public static findHttpResponseMessage(messageToFind: string, data: HttpResponse<any> | any, seachInCaptionOnly = true, includeCaptionInResult = false): string {
        let searchString = messageToFind.toLowerCase();
        let httpMessages = this.getHttpResponseMessage(data);

        for (let message of httpMessages) {
            let fullMessage = Utilities.splitInTwo(message, this.captionAndMessageSeparator);

            if (fullMessage.firstPart && fullMessage.firstPart.toLowerCase().indexOf(searchString) != -1) {
                return includeCaptionInResult ? message : fullMessage.secondPart || fullMessage.firstPart;
            }
        }

        if (!seachInCaptionOnly) {
            for (let message of httpMessages) {
                if (message.toLowerCase().indexOf(searchString) != -1) {
                    if (includeCaptionInResult) {
                        return message;
                    } else {
                        let fullMessage = Utilities.splitInTwo(message, this.captionAndMessageSeparator);
                        return fullMessage.secondPart || fullMessage.firstPart;
                    }
                }
            }
        }

        return null;
    }

    public static checkNoNetwork(response: HttpResponse<any>) {
        if (response instanceof HttpResponse) {
            return response.status == 0;
        }

        return false;
    }

    public static checkAccessDenied(response: HttpResponse<any>) {
        if (response instanceof HttpResponse) {
            return response.status == 403;
        }

        return false;
    }

    public static checkNotFound(response: HttpResponse<any>) {
        if (response instanceof HttpResponse) {
            return response.status == 404;
        }

        return false;
    }

    public static checkIsLocalHost(url: string, base?: string) {
        if (url) {
            let location = new URL(url, base);
            return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
        }

        return false;
    }

    public static splitInTwo(text: string, separator: string): { firstPart: string; secondPart: string } {
        let separatorIndex = text.indexOf(separator);

        if (separatorIndex == -1) return { firstPart: text, secondPart: null };

        let part1 = text.substr(0, separatorIndex).trim();
        let part2 = text.substr(separatorIndex + 1).trim();

        return { firstPart: part1, secondPart: part2 };
    }

    public static safeStringify(object) {
        let result: string;

        try {
            result = JSON.stringify(object);
            return result;
        } catch (error) { }

        let simpleObject = {};

        for (let prop in object) {
            if (!object.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof object[prop] == 'object') {
                continue;
            }
            if (typeof object[prop] == 'function') {
                continue;
            }
            simpleObject[prop] = object[prop];
        }

        result = '[***Sanitized Object***]: ' + JSON.stringify(simpleObject);

        return result;
    }

    public static JSonTryParse(value: string) {
        try {
            return JSON.parse(value);
        } catch (e) {
            if (value === 'undefined') return void 0;

            return value;
        }
    }

    public static TestIsUndefined(value: any) {
        return typeof value === 'undefined';
        //return value === undefined;
    }

    public static TestIsUndefinedOrNull(value: any) {
        if (this.TestIsUndefined(value)) return true;
        return value == null;
    }

    public static TestIsString(value: any) {
        return typeof value === 'string' || value instanceof String;
    }

    public static capitalizeFirstLetter(text: string) {
        if (text) return text.charAt(0).toUpperCase() + text.slice(1);
        else return text;
    }

    public static toTitleCase(text: string) {
        return text.replace(/\w\S*/g, (subString) => {
            return subString.charAt(0).toUpperCase() + subString.substr(1).toLowerCase();
        });
    }

    public static toLowerCase(items: string);
    public static toLowerCase(items: string[]);
    public static toLowerCase(items: any): string | string[] {
        if (items instanceof Array) {
            let loweredRoles: string[] = [];

            for (let i = 0; i < items.length; i++) {
                loweredRoles[i] = items[i].toLowerCase();
            }

            return loweredRoles;
        } else if (typeof items === 'string' || items instanceof String) {
            return items.toLowerCase();
        }
    }

    public static randomNumber(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    public static baseUrl() {
        if (window.location.origin) return window.location.origin;

        return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }

    public static parseDate(date) {
        if (date) {
            if (date instanceof Date) {
                return date;
            }

            if (typeof date === 'string' || date instanceof String) {
                if (date.search(/[a-su-z+]/i) == -1) date = date + 'Z';

                return new Date(date);
            }

            if (typeof date === 'number' || date instanceof Number) {
                return new Date(<any>date);
            }
        }
    }

    public static removeNulls(obj) {
        let isArray = obj instanceof Array;

        for (let k in obj) {
            if (obj[k] === null) {
                isArray ? obj.splice(k, 1) : delete obj[k];
            } else if (typeof obj[k] == 'object') {
                Utilities.removeNulls(obj[k]);
            }

            if (isArray && obj.length == k) {
                Utilities.removeNulls(obj);
            }
        }

        return obj;
    }

    public static debounce(func: (...args) => any, wait: number, immediate?: boolean) {
        var timeout;

        return function () {
            var context = this;
            var args_ = arguments;

            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args_);
            };

            var callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) func.apply(context, args_);
        };
    }

    /**
     * Funzione che restituisce il valore di un numero arrotondato matematicamente al valore corrispondente alla precisione del valore decimale indicato.
     * @param number Numero da arrotondare.
     * @param precision Precisione da utilizzare per l'arrotondamento.
     * Alcuni esempi:
     * console.log(precisionRound(1234.5678, 1));  // output: 1234.6
     * console.log(precisionRound(1234.5678, -1)); // output: 1230
     * console.log(precisionRound(1.005, 2));      // output: 1.01
     */
    public static precisionRound(number: number, precision: number) {
        if (precision < 0) {
            let factor = Math.pow(10, precision);
            return Math.round(number * factor) / factor;
        } else return +(Math.round(Number(number + 'e+' + precision)) + 'e-' + precision);
    }

    /**
     * Funzione che riempe di zeri decimali il numero ricevuto come parametro e lo restituisce come stringa.
     * @param value Valore numerico nel quale inserire gli zeri come valori decimali.
     * @param size Lunghezza di padding.
     */
    public static numberToZeroPadding(value: number, size: number): string {
        return value.toFixed(size).replace('.', ',');
    }

    /**
     * Ricevuta in input una stringa la restituisce nel formato in gg/mm/aaaa.
     * @param data Data da formattare.
     * @param includeHours Indica se includere le ore.
     * @param includeSeconds Indica se includere i secondi.
     * @param includeSeparators Indica se utilizzare i separatori.
     */
    public static formatDateToString(data: Date, includeHours?: boolean, includeSeconds?: boolean, includeSeparators?: boolean): string {
        // Creo un nuovo oggetto Date per evitare l'errore 'TypeError: value.getMonth is not a function'
        let value = new Date(data);

        // Oggetto stringa che rappresenta la data formattata
        let strData: string = '';

        let fistSep = '/';
        let secondSep = ':';

        // Imposto l'utilizzo dei separatori come default
        if (includeSeparators == null) includeSeparators = true;

        // Se specificato di non includere i separatori li svuoto
        if (!includeSeparators) {
            fistSep = '';
            secondSep = '';
        }

        // Formatto la data
        if (value) {
            let mese: number = value.getMonth();

            // Il mese di gennaio parte da 0, quindi incremento di 1
            mese++;

            //return Utilities.printTimeOnly(value) + " di " + Utilities.printDateOnly(value);
            if (!includeHours) strData = String('0' + value.getDate()).slice(-2) + fistSep + String('0' + mese).slice(-2) + fistSep + value.getFullYear();
            else strData = String('0' + value.getDate()).slice(-2) + fistSep + String('0' + mese).slice(-2) + fistSep + value.getFullYear() + ' ' + String('0' + value.getHours()).slice(-2) + secondSep + String('0' + value.getMinutes()).slice(-2);
            if (includeSeconds) strData += secondSep + String('0' + value.getSeconds()).slice(-2);
        }

        // Restituisco la data formattata
        return strData;
    }

    /**
     * Effettua il confronto fra date e restituisce un numerico che vale:
     * 0 se le date sono uguali
     * 1 se la data1 è maggiore della data2
     * -1 se la data1 è minore della data2
     * @param date1 Prima data da confrontare.
     * @param date2 Seconda data da confrontare.
     */
    public static compareDate(date1: Date, date2: Date): number {
        //  Comparazione date con  >, <, <= or >=
        // The ==, !=, ===, and !== operators require you to use date.getTime()

        let d1 = new Date(date1);
        let d2 = new Date(date2);

        // Verifico se le date sono uguali
        let same = d1.getTime() === d2.getTime();
        if (same) return 0;

        // Se non sono uguali le confronto
        if (d1 > d2) return 1;
        if (d1 < d2) return -1;
    }

    /**
     * Merge data of two structures and returns the structure obtained.
     * For each property of the oldData structure checks if a value is defined into the newData. If it's defined use it, otherwise leaves the oldData value.
     * @param oldData Old data of the structure.
     * @param newData New data to merge.
     */
    public static mergeData<T>(oldData: T, newData: T): T {
        // Init result with the oldData
        let data = oldData;

        // Get object properties
        let propArray = Object.getOwnPropertyNames(oldData);

        // For each property checks if a value is defined into the newData to merge it int the result
        propArray.forEach((p) => {
            if (!Utilities.TestIsUndefined(newData[p])) data[p] = newData[p];
        });

        // Returns the merged structure
        return data;
    }

    /**
     * Restituisce la data e ora corrente nel formato locale
     * */
    public static getLocalDate(): Date {
        let date = new Date();
        let newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        let offset = date.getTimezoneOffset() / 60;
        let hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    }

    /**
     * Restituisce la data e ora corrente nel formato stringa locale (no UTC)
     * */
    public static getLocalDateTimeString(): string {
        return this.getLocalDate().toISOString().replace('Z', '');
    }
    /**
     * Restituisce una data nel formato corretto eliminando definitivamente il problema del formato UTC con il fuso orario.
     * @param data Data da elaborare.
     */
    public static getDateWithoutTimezone(data: Date): Date {
        // Imposto la data
        let result: Date = new Date(data);

        var userTimezoneOffset = result.getTimezoneOffset();
        result = new Date(result.getTime() - userTimezoneOffset);

        // Restituisco la data eliminando il fuso orario
        return result;
    }

    /**
     * Transforms the parameters of an object into query string parameters.
     * @param query quey parameters.
     */
    public static toQueryString(query): string {
        var parts = [];
        for (var property in query) {
            var value = query[property];
            if (value != null && value != undefined) parts.push(encodeURIComponent(property) + '=' + encodeURIComponent(value));
        }

        return parts.join('&');
    }

    public static getDataWithQueryParams(queryParams): HttpParams {
        // Usa encodeURIComponent per ogni valore
        let params = new HttpParams();
        Object.keys(queryParams).forEach(key => {
            params = params.set(key, encodeURIComponent(queryParams[key]));
        });

        return params
    }

    /**
     * Find the differences within a component data-grid. highlight cells with previous row.
     * @param row
     * @param array //empty array
     */
    public static highlightCellsWithPreviousRow(row, array) {
        if (row.rowType == 'data' && row.dataIndex != 0) {
            Object.keys(row.values).forEach((value, keys) => {
                //console.log(keys);
                // check if the column is sys_start_datetime (2) && sys_end_datetime (3)
                if (keys != 2 && keys != 3) {
                    if (array[row.dataIndex - 1].values.length >= 1) {
                        if (row.values[value] != array[row.dataIndex - 1].values[value]) {
                            if (array[row.dataIndex - 1].rowElement.cells[keys]?.style != null) {
                                array[row.dataIndex - 1].rowElement.cells[keys].style.backgroundColor = SystemInfoConsts.primaryLigthHoverColor;
                            }
                        }
                    }
                }
            });
            array.push(row);
        } else if (row.rowType == 'data') array.push(row);
    }

    /**
     * Get date in standard format form DB. Utc format
     * @param date Data da elaborare.
     */
    public static getDateStringInUtcFormatWithZoneOffset(date: any, zoneUtcOffset?: number): any {
        return moment
            .utc(date)
            .utcOffset(zoneUtcOffset == null ? 0 : zoneUtcOffset)
            .format('DD/MM/YYYY HH:mm:ss');
    }

    /**
     * Get time in standard format form DB. Utc format
     * @param date Data da elaborare.
     */
    public static getTimeStringInUtcFormat(date: any): any {
        return moment.utc(date).format('HH:mm:ss').valueOf();
    }

    /**
     * Get date in local format form DB.
     * @param date Data da elaborare.
     */
    public static getDateStringInLocalFormat(date: any): any {
        if (!!date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss').valueOf();
        } else {
            return '';
        }
    }

    /**
     * replace string with asterisk.
     * @param date Data da elaborare.
     */
    public static replaceToSecret(number: string): string {
        return number.replace(number.substr(0, number.length - 4), number.substr(0, number.length - 4).replace(/./g, '*'));
    }

    /**
     * Clone an object
     * @param objToClone object to clone
     */
    public static cloneObject(objToClone: any): any {
        return JSON.parse(JSON.stringify(objToClone));
    }

    /* Calculates the unix time of a given date
     * @param date
     * @returns
     */
    public static getUnixTime(date: Date): number {
        return Math.floor(date.getTime() / 1000);
    }

    /**
     * Navigate to a specific target
     * @param target target name
     */
    public static goto(target: string) {
        if ((<any>Object).values(NavigationTarget).includes(target)) {
            window.open(environment.portalBaseUrl + target, '_blank');
        } else {
            throw 'Path location not provided';
        }
    }

    /**
     * Prints a div by name
     * @param divName printable div name
     * (https://github.com/selemxmn/ngx-print/blob/master/src/lib/ngx-print.directive.ts)
     */
    public static printDiv(divName: string, useInnerHtml: boolean = false) {
        let divContent = document.getElementById(divName);
        let printContents = useInnerHtml ? divContent.innerHTML : divContent;
        let width = screen.width;
        let height = screen.height;
        let left = 0; //screen.width - 960;
        let top = 0; //100;
        let popupWin = window.open('', '_blank', `top=${top},left=${left},height=${height},width=${width}`);
        popupWin.document.open();
        //popupWin.document.write(printContents);
        popupWin.document.write(`
      <html>
          <head>
          </head>
          <body>
          ${printContents}
          <script defer>
              function triggerPrint(event) {
              window.removeEventListener('load', triggerPrint, false);
              setTimeout(function() {
                  closeWindow(window.print());
              }, ${this.printDelay});
              }
              function closeWindow(){
                  window.close();
              }
              window.addEventListener('load', triggerPrint, false);
          </script>
          </body>
      </html>`);
        popupWin.document.close();
    }

    /**
     * Convert from base64 to blob
     * @param Base64Image base64 image
     * @returns blob
     */
    public static convertBase64ToBlob(Base64Image: string) {
        // split into two parts
        const parts = Base64Image.split(';base64,');
        // hold the content type
        const imageType = parts[0].split(':')[1];
        // decode base64 string
        const decodedData = window.atob(parts[1]);
        // create unit8array of size same as row data length
        const uInt8Array = new Uint8Array(decodedData.length);
        // insert all character code into uint8array
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // return blob image after conversion
        return new Blob([uInt8Array], { type: imageType });
    }

    /**
     * Handle update on the grid
     * @param options event info
     */
    public static onRowUpdating(options) {
        // Merge the complete record to send it to the api
        return (options.newData = $.extend({}, options.oldData, options.newData));
    }

    /**
     * Get customer account legend
     */
    public static getLegendAccounts(): any[] {
        let legend: any[] = [{ id: 1, color: SystemInfoConsts.primaryLigthHoverColor, label: "Indica che all'interno della riga, in alcune celle ci sono differenze con la riga precedente" }];

        return legend;
    }

    /**
     * convert date to string
     */
    public static convertDateToString(date: Date | null): string | null {
        if (date === null) {
            return null;
        }

        return date.toLocaleString();
    }

    /**
     * convert string to date
     */
    public static checkIllimitateDate(dateString: string): Date | null {
        if (dateString === '9999-12-31T23:59:59.9999999Z') {
            return null;
        }

        return new Date(dateString);
    }

    /**
    *Get date as end of month and day (gg:mm:aaaa 23:59:59.000)
    *@returns end of month and day time for the specified date 
    */
    public static getEndOfMonthDate(date: Date) {
        return new Date(moment(date).endOf('month').set({ month: date.getMonth(), hour: 23, minute: 59, second: 59, millisecond: 0 }));
    }
}

export function assetUrl(url: string): string {
    // @ts-ignore
    const publicPath = __webpack_public_path__;
    const publicPathSuffix = publicPath.endsWith('/') ? '' : '/';
    const urlPrefix = url.startsWith('/') ? '' : '/';

    return `${publicPath}${publicPathSuffix}assets${urlPrefix}${url}`;
}
